import { PatientRelativesAPI } from '@api/patientRelativesAPI'

import { ID } from '@models/base'
import { Option } from '@models/option'

import { AsyncPaginateSelectField, AsyncPaginateSelectFieldProps } from '@components/Form/AsyncPaginateSelect'

import TypeUtil from '@/utils/typeUtil'

type Props<IsMulti extends boolean> = Omit<AsyncPaginateSelectFieldProps<IsMulti>, 'onSearch'> & {
  patientId: ID
}

const QueueNumberPatientRelativeSelectField = <IsMulti extends boolean = false>({
  patientId,
  ...props
}: Props<IsMulti>) => {
  const searchDebounce = async (inputVal: string, page: number) => {    
    const response = await PatientRelativesAPI.getOptionsForQueueNumberForm({
      page: page,
      limit: 10,
      phrase: !TypeUtil.isEmpty(inputVal) ? inputVal : undefined,
      patient_id: patientId,
    })

    if (response?.data) {
      return {
        ...response.data,
        nodes: response.data.nodes.map((patientRelative) => {
          return patientRelative.related_patient !== null
            ? new Option({
                label: patientRelative.related_patient.full_name || '-',
                value: patientRelative.id,
              })
            : new Option({
                label: patientRelative.first_name
                  ? `${patientRelative.first_name} ${patientRelative.last_name ?? ''}`
                  : '-',
                value: patientRelative.id,
              })
        }),
      }
    }
  }

  return (
    <AsyncPaginateSelectField
      {...props}
      key={patientId}
      onSearch={searchDebounce}
      noOptionsMessage={() => 'Patient Relative not found'}
    />
  )
}

export default QueueNumberPatientRelativeSelectField
